import { z } from 'zod';

export const CoverageMatrixSchema = z.object({
  personas: z.array(z.string().min(1)),
  scenarios: z.array(z.string().min(1)),
  coverage: z.record(z.string(), z.boolean()),
  totalCoverage: z.number()
});

export type CoverageMatrix = z.infer<typeof CoverageMatrixSchema>;

type StateSnapshot = {
  persona?: string | null;
  scenario?: string | null;
};

type StateMachineLike = {
  states?: StateSnapshot[] | null;
};

export function buildCoverageMatrix(stateMachine: StateMachineLike): CoverageMatrix {
  const personas = new Set<string>();
  const scenarios = new Set<string>();
  const coverage: Record<string, boolean> = {};

  for (const state of stateMachine.states ?? []) {
    if (state.persona) {
      personas.add(state.persona);
    }
    if (state.scenario) {
      scenarios.add(state.scenario);
    }
    if (state.persona && state.scenario) {
      coverage[`${state.persona}:${state.scenario}`] = true;
    }
  }

  const personaList = Array.from(personas).sort();
  const scenarioList = Array.from(scenarios).sort();
  const totalCells = personaList.length * scenarioList.length;
  const coveredCells = Object.keys(coverage).length;

  return {
    personas: personaList,
    scenarios: scenarioList,
    coverage,
    totalCoverage: totalCells > 0 ? (coveredCells / totalCells) * 100 : 0
  };
}
